import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import Car from "../Car";
import ContactInfo from "./ContactInfo";
import WorkshopAndDate from "../../../../shared/components/WorkshopAndDate";
import BaseServices from "./BaseServices";
import SelectedVehicle from "../../../../shared/components/SelectedVehicle";
import { Box } from "@mui/material";

export default function BookStep2() {

    const { draft } = useSelector((state) => state.reservation);
    const navigate = useNavigate();
    const location = useLocation();

    // Put user on top of page when navigated to this component
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (!draft.workshop) {
            navigate("/");
            return;
        }
        if (!draft.car || !draft.date) {
            const params = new URLSearchParams(location.search);
            params.set('step', '1');
            navigate(`/workshops/${draft.workshop?.id || ''}?${params.toString()}`);
        }
    }, [draft, navigate, location]);

    return (
        <Box className='workshop-page_steps'>
            <Box sx={{ marginBottom: '20px' }}>
                <SelectedVehicle canEdit={false}/>
            </Box>
            <WorkshopAndDate />
            <BaseServices category="extra" />
            <ContactInfo />
        </Box>
    );
}